import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseHealthModel from "../../models/case-health";

export default class CaseHealthRepository extends BaseRepository {
  static modelClass = CaseHealthModel;
  modelName = "case-health";

  async query(caseId) {
    return await super.query({
      urlPath: `case/${caseId}/flags`,
    });
  }
}
